module.exports = __webpack_public_path__ + "static/img/IMG_20241030_100458.1b9066b5.jpg";